import { Typography } from '@cmg/design-system';

export const ShareIndicationsOnlyNote: React.FC = () => {
  return (
    <Typography variant="body2">
      <Typography variant="subtitle2" component="span">
        Note:{' '}
      </Typography>
      Currency and percent demand units are disabled for this offering.
    </Typography>
  );
};
